import classnames from 'classnames'
import NextLink from 'next/link'
import {
  Typography,
  TypographyProps,
  TypographyStyles
} from '@jeromevvb/equinox-lib'

export interface LinkProps extends TypographyProps {
  href?: string
  title?: string
  className?: string
  // just underline the text when hover.
  underline?: boolean
  external?: boolean
  disabled?: boolean
  variantHover?: 'normal' | 'underline'
}

const Link: React.FC<LinkProps> = ({
  href,
  title,
  disabled = false,
  external = false,
  children,
  underline,
  className,
  color = 'secondary',
  ...props
}) => {
  const additionalProps = {
    title,
    target: external ? '_blank' : '_self',
    rel: 'noopener noreferrer'
  }

  if (disabled) {
    return (
      <Typography
        data-testid="link-disabled"
        {...props}
        className="opacity-70 cursor-not-allowed"
      >
        {children}
      </Typography>
    )
  }

  return (
    <NextLink href={href} passHref={true}>
      <a
        css={TypographyStyles({ ...props, color, underline })}
        className={classnames('hover-as-link', className)}
        {...additionalProps}
      >
        {children}
      </a>
    </NextLink>
  )
}

export default Link
